<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('zhuima.prize.prizeName')" prop="prizeName">
                <a-input v-model="queryParam.prizeName" :placeholder="$t('zhuima.prize.inputPrizeName')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="奖品图片" prop="prizeCover">-->
<!--                <a-input v-model="queryParam.prizeCover" placeholder="请输入奖品图片" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.prize.probability')" prop="probability">
                  <a-input v-model="queryParam.probability" :placeholder="$t('zhuima.prize.inputProbability')" allow-clear/>
                </a-form-item>
              </a-col>
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="是否禁用" prop="isBan">-->
<!--                  <a-input v-model="queryParam.isBan" placeholder="请输入是否禁用" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.userPrize.address')" prop="address">
                  <a-input v-model="queryParam.address" :placeholder="$t('zhuima.userPrize.inputAddress')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['prize:prize:add']">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['prize:prize:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['prize:prize:remove']">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <span slot="isBan" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.yes')" :unCheckedChildren="$t('common.no')" v-model="record.isBan == 1" @change="changeIsOpen($event,record)"/>
        </span>
        <img slot="prizeCover" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.prizeCover" v-image-preview :src="record.prizeCover">

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['prize:prize:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['prize:prize:edit']">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['prize:prize:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['prize:prize:remove']">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePrize,changeIsOpen, delPrize } from '@/api/prize/prize'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Prize',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        prizeName: null,
        prizeCover: null,
        probability: null,
        isBan: null,
        address: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('zhuima.prize.prizeName'),
          dataIndex: 'prizeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.prize.prizeCover'),
          dataIndex: 'prizeCover',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'prizeCover' },
        },
        {
          title: this.$t('zhuima.prize.probability'),
          dataIndex: 'probability',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.prize.isBan'),
          dataIndex: 'isBan',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isBan'},
        },
        {
          title: this.$t('zhuima.prize.prizeType'),
          dataIndex: 'isOffline',
          ellipsis: true,
          align: 'center',
          customRender: (t, r, index) => {
            if(t == 0) {
              return this.$t('zhuima.prize.prizeTypeVip')
            }else if(t == 1) {
              return this.$t('zhuima.prize.prizeTypePhysical')
            }
            return t
          }
        },
        {
          title: this.$t('zhuima.prize.vipDays'),
          dataIndex: 'vipDays',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    /** 查询抽奖奖品列表 */
    getList () {
      this.loading = true
     pagePrize(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },



    changeIsOpen (e,record) {
      record.isBan = e ? true : false
      changeIsOpen({id:record.id,isBan:record.isBan}).then(response => {
        this.$message.success(
          this.$t('zhuima.prize.operationSuccess')
        )
        return  record.isBan = e ? 1 : 0
      })
    },



    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        prizeName: undefined,
        prizeCover: undefined,
        probability: undefined,
        isBan: undefined,
        address: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delPrize(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('prize/prize/export', {
            ...that.queryParam
          }, `${that.$t('zhuima.prize.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
